export default {"src":"/_next/static/media/why-one-customers-icon.2e526a96.svg","height":66,"width":108,"blurWidth":0,"blurHeight":0};